<script setup lang="ts">
defineProps<{
  direction: "prev" | "next";
  ariaLabel?: string;
}>();
</script>

<template>
  <UButton
    square
    size="sm"
    class="p-3.25"
    :aria-label="(ariaLabel ?? direction === 'prev') ? $t('ui.previous') : $t('ui.next')"
    :icon="direction === 'prev' ? 'icon:arrowLeft' : 'icon:arrowRight'"
    variant="outline"
  />
</template>
